import { render, staticRenderFns } from "./PatientsByDueDateListSingleDay.vue?vue&type=template&id=70ac04c3"
import script from "./PatientsByDueDateListSingleDay.vue?vue&type=script&lang=js"
export * from "./PatientsByDueDateListSingleDay.vue?vue&type=script&lang=js"
import style0 from "./PatientsByDueDateListSingleDay.vue?vue&type=style&index=0&id=70ac04c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports